import React from 'react';
import './Friends.css';
import {Avatar, Button} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {Link} from 'react-router-dom';
import { AlternateEmailOutlined } from '@material-ui/icons';
import { useImperativeHandle } from 'react';

function Friends({profile, name, userId, findFri, email}) {
    
    return (
        <div className="friends">
                <Button
                ><Avatar src={profile} /> <Link to={`/friend/${email}`}><p>{name}</p></Link>
                <MoreVertIcon className="mores__option"/></Button>
        </div>
    )
}

export default Friends
